// Lib
import React, { ReactElement } from 'react';

// Components
import TiptapToggleMarkTool from './TiptapToggleMarkTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';

const TiptapItalicTool = (props: ToolbarToolProps): ReactElement => <TiptapToggleMarkTool {...props} mark="italic" />;

export default TiptapItalicTool;
